var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/helpers/useSelectedGroupNode.ts";
import { combine } from 'effector';
import { useStore } from 'effector-react';
import { getNode } from "../../../classifier-service";
import { isDynamicBimElementReferenceNode, isReferenceNode } from "../../../classifier-service/Node";
import { findInFlatTree } from "../../ClassifierTree/utils";
import { isApiFlatNode } from "../../ClassifierTree/createTree";
import { importEstimationService } from "../model";
import { currentGroup$ } from "../../../classifier-editor/ClassifierTree";
import { isEstimationTreeNode } from "./isEstimationTreeNode"; //TODO: Вынести из модулей код такой же код как ниже и переиспользовать тут

export var selectedGroupNode$ = combine({
  ɔ: [{
    nodes: importEstimationService.classifierService.nodes$,
    currentGroup: currentGroup$,
    flatTree: importEstimationService.treeModel.flatTree$
  }, function (_ref) {
    var flatTree = _ref.flatTree,
        currentGroup = _ref.currentGroup,
        nodes = _ref.nodes;

    if (!currentGroup) {
      return null;
    }

    var flatNode = findInFlatTree(flatTree, currentGroup.path);

    if (flatNode && isApiFlatNode(flatNode)) {
      var node = getNode(nodes, flatNode.ref);
      return node && isEstimationTreeNode(node) ? node : null;
    }

    return null;
  }],
  config: {
    name: "selectedGroupNode$",
    sid: "-bufzh"
  }
});
export function useSelectedGroupNode(_ref2) {
  var nodes$ = _ref2.nodes$;
  var selectedGroup = useStore(selectedGroupNode$);
  var nodes = useStore(nodes$);

  if (!selectedGroup) {
    return selectedGroup;
  }

  if (isDynamicBimElementReferenceNode(selectedGroup) || isReferenceNode(selectedGroup)) {
    selectedGroup = getNode(nodes, selectedGroup.element);
  }

  return selectedGroup;
}